<script setup lang="ts">
import { appUrl } from '../config/runtime-config';
import { FAQ } from '../content/site-content';

/**
 * Le domande, in `<details>` nativi: si aprono senza una riga di JavaScript,
 * si stampano, e la ricerca del browser (Ctrl+F) trova anche il testo chiuso
 * sui browser recenti. Nessun accordion fatto in casa.
 */
</script>

<template>
  <section id="domande" class="section">
    <div class="page faq__grid">
      <div class="section__head faq__head">
        <span class="eyebrow">Domande</span>
        <h2 class="section__title">Quello che chiedono tutti</h2>
        <p class="section__lead">Prima dell’asta, di solito la sera prima.</p>

        <a class="button button--accent faq__cta" :href="appUrl">Apri Falasta</a>
      </div>

      <div class="faq__list">
        <details v-for="entry in FAQ" :key="entry.id" class="qa">
          <summary class="qa__q">{{ entry.question }}</summary>
          <p class="qa__a">{{ entry.answer }}</p>
        </details>
      </div>
    </div>
  </section>
</template>

<style scoped>
.faq__grid {
  display: grid;
  gap: clamp(1.5rem, 4vw, 3rem);
  align-items: start;
}

.faq__head {
  margin-bottom: 0;
}

.faq__cta {
  margin-top: 1.25rem;
}

.qa {
  border-bottom: 1px solid var(--color-border);
}

.qa__q {
  /* Il triangolino di default è minuscolo e non si allinea: lo sostituisce il
     `+`/`−` disegnato sotto. */
  list-style: none;
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  padding: 0.9rem 0;
  color: var(--color-heading);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
}

.qa__q::-webkit-details-marker {
  display: none;
}

.qa__q::after {
  content: '+';
  margin-left: auto;
  color: var(--color-accent-text);
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
}

.qa[open] .qa__q::after {
  content: '−';
}

.qa__a {
  padding: 0 0 1rem;
  color: var(--color-muted);
  font-size: 0.9375rem;
  max-width: 44rem;
}

@media (min-width: 60rem) {
  .faq__grid {
    grid-template-columns: 0.8fr 1.2fr;
  }
}
</style>
